import PUBLIC_KEY from "../constants/public-key.c";
import base64 from "base-64";
import utf8 from "utf8";
import { JSEncrypt } from "jsencrypt";
import { CARDINAL_URL } from "../constants/api-path.c";
import i18n from "../i18n";
import HKDICON from "../components/assets/hkd-amount.png";
import JPYICON from "../components/assets/jpy-amount.png";
import SGDICON from "../components/assets/sgd-amount.png";
import USDICON from "../components/assets/usd-amount.png";
const privateKey = `-----BEGIN RSA PRIVATE KEY-----
MIIEpAIBAAKCAQEAuPDHXuzVo+VJDvKWaQnQbikzB4tfq13nkriZGqop4q0KECWb
oBVsz249WUmGxoQMEW5BmSTSoGeUhxCJ1+m0LfRZ7HfTFBqNR1npbETsq55AzsPa
cwLH+bgMiQI0CkNxDRk2CEu5LVH+Ug+BG3Uq4ngROA0g1B+Sc/k7yjJQ3Aaoxsh5
aA+eQxCyW26Dt16Vy7qbRFM3UNoLTlDsZsjsg0IWPwtLSnk5HdySHF/0ALvg33Bx
ZwHAyvjsEClKpvs/S8soQwtAZ7ryxFMJJqTIVCjN9vof2c5H7nmk+PJ9idVeAlN0
ygafY7xd1Rpk8P0EFJKj4HUqRpPGLE8lglUsHQIDAQABAoIBAAg9ciSgmMQ8qwyn
clwru8WswEFNzG1uOasn3mp5unQHEbO2eUCgs8BqQQGBbSfbKk58gx+3rErJUqzR
59Je71A82uTWUelLZZAQSX4xc/oRiwGraEhHj3Fo6eYQ2xC6AId84BNujEmgpZwy
ZKY8ijSc9OdybkwFPBk+uZNAuqmS7v1Et7Bln8vzl1c+6IlQ0L8TyUz5Hih0xEf4
XCF5mE6Gpbuy2Gb9KBRZcV/7+HSawwy3aVpfD32LeWfGZANaKhm6/P/GsNluh9qm
+N2SNHYVsKSNc30/CiVhHnfmlt+omq2lZdg4UxiyF19TJxtX/Rt89O7+0myTp8OF
OLuuEmECgYEA3ls1LVa0LY/FfRVMfyEvdjNi4uSCD30S+I1vSWmCvU+5d8xJn/IY
EFNVb78na1+HfeRwYkykplrKDU1fSShMMxTIaUau0BMLL/gz9aowA5hn33KGPFYI
JZqx+Iy8oX1ve8JjDV4waBj9ELnuZ2h6NNio5OZMqsRXe7uTLtdlJ88CgYEA1OxN
bUkAPsPUY1DOkvHx7GeM/b5KN9IeVERVAM/ibwPupUGcIx5hPbM/y0Tn1m5shsvK
7JRdpDROhhp6az+4Y4tuKsEfXWIRI3uRF0vK29ps4P6ofODVnhUSYfzzVj2KJm+g
JExvhnUTdalUGx9igcdOAULFewCmhLnw5Q3vfFMCgYEAn/ERdjRo1GEXWFsKtGOF
hUt/NN/TohqAm+L4iuDnVw9SxJZg2zlED/IxgXkJfNWxW2AHat3gjXy+3ASspq3i
6ddoNTnPowIfyPiLP4mUkfF9vh/d6OalY487tyJcyPi2SVpQ75uxzB81YWOs1hsz
1HGIQ2ZY/XjPyMPrIgVz0McCgYEAueK+yd0EkMcoYbhHUDRXj5rrlQ8O/mK7RbgO
OdJDjcXyD2YTKPm5zULzO8OhXywyJRA/zYDNq7BaqWruWzlbAdTVThAiEMWvzrlu
9tadeIjdqyPH9pXXCNa+oLtTuYOqW1nyhh4Q82K8pWk52x/wQPq92A3yGCt+NLuc
WmxrGq8CgYBKTZEkcE8MTCpB0k1RT4QwFIaLtWmMXRXj5U008gHfMBdpwd3vA1Zd
o+mbN5lZSRjhmnFdy0RSqPltUZ4FuQlCSf3VUJhBAWV82r5G4lTCWJhlCo+EhftN
udYJ1zPoSdQvDaQJfDyuJ7+MWQ9yyEtXnZD31Q/ZBZa3QW+8cpxOxw==
-----END RSA PRIVATE KEY-----`
export const encryptText = (plainText: string) => {
  if (window) {
    // Encrypt with the public key...
    var encrypt = new JSEncrypt();
    encrypt.setPublicKey(PUBLIC_KEY);
    return encrypt.encrypt(plainText);
  }
};

export const decryptText = (encryptedBase64: string) => {
  if (window) {
    const decryptor = new JSEncrypt();
    decryptor.setPrivateKey(privateKey);
    
    const decrypted = decryptor.decrypt(encryptedBase64);
    return decrypted;
  }
};

export const pick = (object: any, keys: any) => {
  return keys.reduce((obj: any, key: any) => {
    if (object && Object.prototype.hasOwnProperty.call(object, key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
};

export const stringToBase64 = (text: string) => {
  let bytes = utf8.encode(text);
  return base64.encode(bytes);
};

export const base64ToString = (encoded: string) => {
  if (!encoded) return "";
  let bytes = base64.decode(encoded);
  return utf8.decode(bytes);
};


export function performDDC(bin: any, jwt: any) {
  let innerHtml =
    "<body onload='document.collectionForm.submit();'>" +
    "<form id='collectionForm' name='collectionForm' method='POST' action='" +
    `${CARDINAL_URL}/V1/Cruise/Collect` +
    "' >" +
    "<input type='hidden' name='Bin' value='" +
    bin +
    "'>" +
    "<input type='hidden' name='JWT' value='" +
    jwt +
    "'>" +
    "</form>" +
    "</body>";

  //set iframe properties
  let iframe = document.createElement("iframe");
  iframe.id = "ddcIframe";
  iframe.width = "0";
  iframe.height = "0";
  iframe.style.visibility = "hidden";
  iframe.style.display = "none";
  iframe.srcdoc = innerHtml;
  document.body.appendChild(iframe);
}

export function performRCP(jwt: any, MID: any) {
  let innerHtml =
    "<body onload='document.challengeForm.submit();'>" +
    "<form id='challengeForm' target='_parent' name='challengeForm' method='POST' action='" +
    `${CARDINAL_URL}/V2/Cruise/StepUp` +
    "' >" +
    "<input type='hidden' name='MD' value='" +
    MID +
    "'>" +
    "<input type='hidden' name='JWT' value='" +
    jwt +
    "'>" +
    "</form>" +
    "</body>";

  //set iframe properties
  let iframe = document.createElement("iframe");
  iframe.id = "challengeIframe";
  iframe.width = "0";
  iframe.height = "0";
  iframe.style.visibility = "hidden";
  iframe.style.display = "none";
  iframe.srcdoc = innerHtml;
  document.body.appendChild(iframe);
}

export function getDate(dateString: any) {
  // Create a new Date object from the provided string
  const dateObj = new Date(dateString);

  // Extract day, month, and year components
  const day = String(dateObj.getUTCDate()).padStart(2, '0');
  const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
  const year = dateObj.getUTCFullYear();

  // Format the components as DD/MM/YYYY
  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
}

export function translateCountries(countries: {
  label: string,
  value: string,
}[]) {
  return countries.map((item) => {
    return { label: i18n.t(`countryNames.${item.label}`), value: item.value };
  });
}

export function generateDateArray() {
  const result = [];
  const today = new Date();
  const endDate = new Date(today.getFullYear() + 15, 11); // December of the end year

  let currentDate = new Date(today.getFullYear(), today.getMonth());

  while (currentDate <= endDate) {
    const formattedMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const formattedYear = (currentDate.getFullYear() % 100).toString().padStart(2, '0');
    result.push({
      label: `${formattedMonth}/${formattedYear}`,
      value: `${formattedMonth}/${formattedYear}`
    });

    // Move to the next month
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return result;
}

// filtering countries list to return all the countries without countries in array and then adding those on top

export const getNewListTranslatedCountriesOnTop = (COUNTRIES: any, countriesValueToBeShownOnTop?: any) => {
  if (countriesValueToBeShownOnTop && countriesValueToBeShownOnTop?.length > 0) {
    const countriesRemovedFromList = COUNTRIES?.filter((item: any) => !countriesValueToBeShownOnTop?.includes(item.value));
    const countriesToBeShownOnTop = COUNTRIES?.filter((item: any) => countriesValueToBeShownOnTop?.includes(item.value));
    const countriesListWithJapanOnTop = [...countriesToBeShownOnTop, ...countriesRemovedFromList];
    return translateCountries(countriesListWithJapanOnTop);
  } else {
    return translateCountries(COUNTRIES);
  }
}


export const getCurrencyIconImg = (currency: any) => {
  if (currency === "JPY") {
    return JPYICON
  } else if (currency === "SGD") {
    return SGDICON
  } else if (currency === "HKD") {
    return HKDICON
  }
  else if (currency === "USD") {
    return USDICON
  } else {
    return currency;
  }
}